import React from "react";
import { Container } from "@mui/material";
import { CustomerHeader } from "asset";
import Slider from "react-slick";

const ClientReviews = () => {
  const customerReview = [
    {
      img: "https://picsum.photos/200/300",
      name: "John Doe",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "CEO, XYZ Company",
    },
    {
      img: "https://picsum.photos/200/300",
      name: "Immanual Macron",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "President , The Republic of France",
    },
    {
      img: "https://picsum.photos/200/300",
      name: "Narendra Modi",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "Prime Minister , India",
    },
    {
      img: "https://picsum.photos/200/300",
      name: "Donald Trump",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "President , USA",
    },
    {
      img: "https://picsum.photos/200/300",
      name: "Borish Johnson",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "Prime Minister , UK",
    },
    {
      img: "https://picsum.photos/200/300",
      name: "Imran Khan",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat aperiam et dolorum error nihil eius consectetur obcaecati ut mollitia natus, quae consequuntur non aliquam quos!",
      designation: "Prime Minister , Pakistan",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    dotsClass: "slick-dots ",
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="home-customer-section">
      <Container>
        <div className="home-customer-container">
          <div className="home-customer-container-header flex-column align-items-center ">
            <img
              src={CustomerHeader}
              alt="''"
              className="home-customer-container-header-image"
            />

            <h1 className="home-customer-container-header-title">
              OUR EXHORT HAPPY CLIENTS SAY !
            </h1>
            <p className="home-customer-container-header-desc">
              Why people believe in us is because we do not believe in word of
              mouth we believe in work. We try to give you the best thats why
              some of our clients give us a testimonials
            </p>
          </div>
          <div className="home-customer-content  ">
            <Slider {...settings}>
              {customerReview &&
                customerReview.map((data, index) => {
                  return (
                    <div
                      key={index}
                      // style={{
                      //   minWidth: `${sliderWidth}px`,
                      // }}
                      className="outer-customer-slider"
                    >
                      <div className="home-customer-slider-children flex-column justify-content-between ">
                        <div className="home-customer-slider-children-profile flex-row align-items-center gap-2">
                          <img
                            src={data.img}
                            alt="Profile"
                            className="home-customer-slider-children-profile-picture"
                          />

                          <span className="home-customer-slider-children-profile-details">
                            <h3>{data.name}</h3>
                            <p>{data.designation}</p>
                          </span>
                        </div>
                        <div className="home-customer-slider-children-message">
                          <p>{data.review}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ClientReviews;
